import { type LinkListSection as LinkListSectionType } from '@/features/cms/components/CMS/types'
import { NextLink } from '@/features/shared/elements/Link'
import { spacing } from '@/features/shared/theme/tokens'
import { screenSizes } from '@shipt/design-system-themes'
import { Body, Headline } from '@shipt/design-system-typography'
import styled from 'styled-components'

export const LinkListSection = ({ data }: { data: LinkListSectionType['data'] }) => {
  const { links } = data
  return (
    <>
      {links.map(({ data: { heading, links: linkList } }) => (
        <LinkGroup key={heading}>
          <LinkGroupHeading variant="secondary" size="sm" as="h3">
            {heading}
          </LinkGroupHeading>
          <LinkListWrapper>
            {linkList.map(({ data: { link } }) => (
              <Body key={link.url} size="md">
                <NextLink href={link.url} prefetch={false} showUnderline>
                  {link.text}
                </NextLink>
              </Body>
            ))}
          </LinkListWrapper>
        </LinkGroup>
      ))}
    </>
  )
}

const LinkGroupHeading = styled(Headline)`
  margin-bottom: 1rem;
`

const LinkGroup = styled.div`
  margin-bottom: 2rem;
`

const LinkListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${spacing('lg')};
  margin: ${spacing('sm', 0)};

  @media ${screenSizes.lgMobile} {
    gap: ${spacing('xl')};
  }

  @media ${screenSizes.tablet} {
    grid-template-columns: repeat(4, 1fr);
  }

  @media ${screenSizes.smDesktop} {
    grid-template-columns: repeat(6, 1fr);
  }
`
